<template>
    <div class="apprentice-simple-card skills">
        <div
            class="not-found with-header empty-skills-list"
            v-if="skills.length === 0">
            <div
                class="btn-add-circle icon"
                v-b-tooltip.hover
                :title="$t('quest.add_skill')"
                @click="newSkill"></div>
            <div class="alert-notice">{{ $t('quest.no_skills_found') }}</div>
        </div>

        <div
            class="skills"
            v-else>
            <b-button
                class="btn-add btn-new-skill"
                variant="primary"
                @click="newSkill">
                {{ $t('quest.new_skill') }}
            </b-button>

            <ul class="list-group skills-group-list">
                <li
                    class="list-group-item skill-item"
                    v-for="(skill, index) in skills"
                    :key="index">
                    <div class="skill-name">
                        {{ skill.name }}
                    </div>
                    <div class="skill-actions">
                        <b-button
                            class="btn-settings"
                            v-b-tooltip="$t('common.edit')"
                            variant="primary-icon-only"
                            @click="editSkill(skill.id)"></b-button>

                        <b-button
                            class="btn-remove"
                            variant="danger-icon-only"
                            @click="deleteSkill(skill.id)"
                            :v-b-tooltip="$t('common.delete')"></b-button>
                    </div>
                </li>
            </ul>
        </div>

        <b-modal
            id="quest-edit-skill-modal"
            :title="$t('quest.skill')"
            :ok-title="$t('common.save')"
            :cancel-title="$t('common.cancel')"
            cancel-variant="outline-primary"
            modal-class="apprentice-default-modal"
            @ok="saveSkill()">
            <!-- name -->
            <div class="add-skill">
                <b-form-input
                    v-model="form_name"
                    :placeholder="$t('quest.skill')"></b-form-input>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'design-2021-quest-edit-skills-component',
    props: ['questId', 'skillsIn'],
    data() {
        return {
            skills: this.skillsIn,
            form_id: null,
            form_name: null,
        };
    },
    methods: {
        newSkill() {
            this.form_id = null;
            this.form_name = null;

            this.$bvModal.show('quest-edit-skill-modal');
        },
        saveSkill() {
            if (this.form_id == null) {
                this.addSkill();
            } else {
                this.saveEditSkill();
            }
        },
        addSkill() {
            this.alert.saving();

            var data = {
                name: this.form_name,
            };

            this.axios.post(this.routes.questEditSkillAdd(this.questId), data).then(
                (response) => {
                    this.skills = response.data.skills;
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        editSkill(id) {
            for (const skill of this.skills) {
                if (skill.id == id) {
                    this.form_id = id;
                    this.form_name = skill.name;

                    this.$bvModal.show('quest-edit-skill-modal');
                }
            }
        },
        saveEditSkill() {
            this.alert.saving();

            var data = {
                id: this.form_id,
                name: this.form_name,
            };

            this.axios.post(this.routes.questEditSkillEdit(this.questId), data).then(
                (response) => {
                    this.skills = response.data.skills;
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        deleteSkill(id) {
            this.alert
                .confirm(this.$t('quest.delete_skill'), this.$t('quest.are_you_sure_you_want_to_delete_this_skill'))
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        this.axios.delete(this.routes.questEditSkillDelete(this.questId, id)).then(
                            (response) => {
                                this.skills = this.skills.filter((skill) => skill.id !== id);
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
    },
};
</script>

<style scoped lang="scss">
.skills {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-content: center;
}

.btn-new-skill {
    align-self: flex-end;
    margin-bottom: 15px;
}

.skills-group-list {
    flex-direction: column;
    flex-wrap: wrap;
}

.skills-group-list .skill-item {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 10px 15px;
    border: none;
    margin-bottom: 10px;

    &:not(:last-child) {
        border-bottom: 3px dotted $border-color;
    }
}

.skill-name {
    flex: 1 0;
    margin-bottom: 8px;
}

.skill-actions {
    display: flex;
    justify-content: flex-end;
    flex: 1 0 100%;
}

.skill-actions .btn:last-child {
    margin-left: 8px;
}

.empty-skills-list {
    margin-top: 45px;
    margin-bottom: 45px;
}

@media (min-width: 992px) {
    .skill-name {
        margin-bottom: 0;
    }

    .skill-actions {
        flex: 0 1 auto;
        margin-left: 15px;
        align-self: baseline;
    }
}
</style>
